<template>
    <b-modal ref="client-card-modal" @ok="clientCardModalOk">
      <template v-slot:modal-header="{}">
        <div>{{ $store.state.localization.data.mainPage.clients.pageLabel }}</div>
      </template>
      <div style="font-size: 13px">
        <b-tabs>
            <MainTab
              v-bind:user="user"
              ref="main-tab"
            ></MainTab>
            <RolesTab
              v-bind:user="user"
              v-bind:allRoles="roles"
              ref="roles-tab"
            ></RolesTab>
            <CompaniesTab
              v-bind:user="user"
              v-bind:allCompanies="companies"
              ref="companies-tab"
            ></CompaniesTab>
        </b-tabs>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="success" style="font-size: 12px" @click="ok()">{{
          $store.state.localization.data.common.table.ok
        }}</b-button>
        <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
          $store.state.localization.data.common.table.cancel
        }}</b-button>
      </template>
    </b-modal>
  </template>
  
  <script>
  import MainTab from "./MainTab.vue";
  import RolesTab from "./RolesTab.vue";
  import CompaniesTab from "./CompaniesTab.vue";

  import { userService } from "../../../services";

  export default {
    name: "UpdateClientPage",
    components: {
      MainTab,
      RolesTab,
      CompaniesTab
    },
    data() {
      return {
        user: null,
        roles: [],
        companies: []
      };
    },
    methods: {
      open(user, roles, companies) {
        this.user = user;
        this.roles = roles;
        this.companies = companies;

        this.$refs["client-card-modal"].show();
      },
      async clientCardModalOk(event) {
        if (!this.$refs["main-tab"].validate()) {
          event.preventDefault();
          return;
        }

        const mainData = this.$refs["main-tab"].getMainData();
        const roles = this.$refs["roles-tab"].getRoles();
        const companies = this.$refs["companies-tab"].getCompanies();

        const user = {
          userId: mainData.id,
          isActive: mainData.isActive,
          userName: mainData.userName,
          email: mainData.email,
          password: mainData.password,
          roles: roles,
          companies: companies
        };
        
        const updateUserResponse = await userService.updateUser(user);

        if (
          updateUserResponse.isSuccess &&
          updateUserResponse.data &&
          updateUserResponse.data.countUpdatedRows != 0
        ) {
          this.$emit("clientUpdatedSuccessEvent", user);
        } else {
          this.$emit("clientUpdatedFailEvent");
        }
      },
    },
  };
  </script>
  